<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Disciple d'Emmaus" />
            <DisCiple2 />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import DisCiple2 from '../Disciple2/DisCiple2.vue'

export default {
    name: 'Disciple2Page',
    components: {
        NavBar,
        PageTitle,
        DisCiple2,
        FooterComp,
    }
}
</script>